import { render, staticRenderFns } from "./CreateScreeningTest.vue?vue&type=template&id=346fde92&scoped=true&"
import script from "./CreateScreeningTest.vue?vue&type=script&lang=ts&"
export * from "./CreateScreeningTest.vue?vue&type=script&lang=ts&"
import style0 from "./CreateScreeningTest.vue?vue&type=style&index=0&id=346fde92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346fde92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VIcon,VRow,VTextField})
